var $ea41d6dadb4aad60$exports = {};
$ea41d6dadb4aad60$exports = {
    "clear": `Golire`,
    "invalid": `(nevalid)`,
    "loading": `Se \xeencarc\u{103}...`,
    "noResults": `Niciun rezultat`
};


export {$ea41d6dadb4aad60$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
